import { render, staticRenderFns } from "./OnboardingHeader.vue?vue&type=template&id=376a72b6&"
import script from "./OnboardingHeader.vue?vue&type=script&lang=js&"
export * from "./OnboardingHeader.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingHeader.vue?vue&type=style&index=0&id=376a72b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports